/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MeasurementConfiguration } from "./MeasurementConfiguration";
import {
  MeasurementConfigurationFromJSON,
  MeasurementConfigurationFromJSONTyped,
  MeasurementConfigurationToJSON,
  MeasurementConfigurationToJSONTyped,
} from "./MeasurementConfiguration";

/**
 *
 * @export
 * @interface ApiFrdMeasurementconfigurationsList200Response
 */
export interface ApiFrdMeasurementconfigurationsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiFrdMeasurementconfigurationsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiFrdMeasurementconfigurationsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiFrdMeasurementconfigurationsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<MeasurementConfiguration>}
   * @memberof ApiFrdMeasurementconfigurationsList200Response
   */
  results: Array<MeasurementConfiguration>;
}

/**
 * Check if a given object implements the ApiFrdMeasurementconfigurationsList200Response interface.
 */
export function instanceOfApiFrdMeasurementconfigurationsList200Response(
  value: object
): value is ApiFrdMeasurementconfigurationsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiFrdMeasurementconfigurationsList200ResponseFromJSON(
  json: any
): ApiFrdMeasurementconfigurationsList200Response {
  return ApiFrdMeasurementconfigurationsList200ResponseFromJSONTyped(json, false);
}

export function ApiFrdMeasurementconfigurationsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiFrdMeasurementconfigurationsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(MeasurementConfigurationFromJSON),
  };
}

export function ApiFrdMeasurementconfigurationsList200ResponseToJSON(
  json: any
): ApiFrdMeasurementconfigurationsList200Response {
  return ApiFrdMeasurementconfigurationsList200ResponseToJSONTyped(json, false);
}

export function ApiFrdMeasurementconfigurationsList200ResponseToJSONTyped(
  value?: ApiFrdMeasurementconfigurationsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(MeasurementConfigurationToJSON),
  };
}
